import { MetricNature } from '@upright/common/model/input/types';
import { RequestStatus } from '@upright/ui/api/common/types';
import { TooltipReadMoreLink } from '@upright/ui/common/generic/components/tooltips/common-styles';
import { usePaiLensContext } from '@upright/ui/common/upright/core/impact-lenses/pais/common/use-pai-lens-context';
import { KBUrl } from '@upright/ui/common/upright/kb-urls';
import { values } from 'lodash';
import Skeleton from 'react-loading-skeleton';

export function PaiLensSourceDescriptionTooltip() {
  const ctx = usePaiLensContext();
  if (!ctx) {
    return <></>;
  }
  const data = ctx.data;
  if (data.loadingStatus === RequestStatus.LOADING) {
    return <Skeleton width="5.0em" />;
  }
  const items = data.pais;
  if (!items) {
    return <>Error</>;
  }
  return <>{toSourceDescriptionTooltipText(values(items), KBUrl.METHODOLOGY_PAIS)}</>;
}

interface WithMetric {
  nature?: MetricNature | undefined;
}

export function toSourceDescriptionTooltipText(data: WithMetric[], kbUrl: KBUrl) {
  const anyDirectDisclosures = !!data.find(d => d.nature === MetricNature.DIRECT_DISCLOSURE);
  const anyNonDirectDisclosures = !!data.find(d => d.nature !== MetricNature.DIRECT_DISCLOSURE);
  if (anyDirectDisclosures && anyNonDirectDisclosures) {
    return (
      <>
        Data includes both modelled estimates by the Upright net impact model and direct disclosures by the company. The
        Upright net impact model is a mathematical model of the global economy that integrates information from a
        variety of public data sources to produce comparable net impact profiles of companies, along with complementary
        indicators.
        <TooltipReadMoreLink href={kbUrl} />
      </>
    );
  } else if (anyDirectDisclosures) {
    return 'Data is directly based on disclosures by the company.';
  } else {
    return (
      <>
        Data consists of modelled estimates by the Upright net impact model. The Upright net impact model is a
        mathematical model of the global economy that integrates information from a variety of public data sources to
        produce comparable net impact profiles of companies, along with complementary indicators.
        <TooltipReadMoreLink href={kbUrl} />
      </>
    );
  }
}
